import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";
import { DoorOpeningScreen } from "~/components/DoorOpeningScreen";
import { AppHeader } from "~/components/layout/AppHeader";
import { ThaliaHeader } from "~/components/layout/ThaliaHeader";

export const Route = createFileRoute("/clickncollect/opening")({
	beforeLoad: () => {
		document.title = "bacehub | Startseite";
	},
	component: RouteComponent,
	validateSearch: zodValidator(
		z.object({
			pickupId: z.string(),
			unlockRequestId: z.string(),
			snc: z.boolean().optional(),
			thalia: z.boolean().optional(),
		})
	),
});

export default function RouteComponent() {
	const navigate = useNavigate();
	const { pickupId, unlockRequestId, snc, thalia } = Route.useSearch();
	return (
		<DoorOpeningScreen
			unlockRequestId={unlockRequestId}
			header={thalia ? <ThaliaHeader /> : <AppHeader showHelpButton={true} />}
			onExit={() => navigate({ to: "/" })}
			onOpened={() => {
				navigate({
					from: Route.fullPath,
					to: "/clickncollect/collect",
					search: {
						pickupId,
						unlockRequestId,
						...(snc ? { snc: true } : {}),
						...(thalia ? { thalia: true } : {}),
					},
				});
			}}
			onClosed={() => {
				navigate({
					from: Route.fullPath,
					to: "/clickncollect/finish",
					search: { pickupId, ...(snc ? { snc: true } : {}), ...(thalia ? { thalia: true } : {}) },
				});
			}}
		/>
	);
}
